import Body from '../../body/Body';

export default class Scroller extends Phaser.GameObjects.Sprite {
    private isDragging: boolean = false;

    constructor(scene: Phaser.Scene, x: number, y: number) {
        super(scene, x, y, 'atlas', 'blank');

        this.setOrigin(0.5, 0);
        this.setDisplaySize(Body.MASK.WIDTH, Body.MASK.HEIGHT);
        this.setAlpha(0.01);

        this.setInteractive();
        this.on('pointerdown', this.startDrag, this);
        this.on('pointerup', this.stopDrag, this);
        this.on('pointermove', this.drag, this);
    }

    startDrag() {
        this.isDragging = true;
    }

    stopDrag() {
        this.isDragging = false;
    }

    drag(pointer: Phaser.Input.Pointer) {
        if (!this.isDragging) return;

        let deltaY = pointer.position.y - pointer.prevPosition.y;
        this.emit('moved', deltaY);
    }
}
